<template>
  <v-card flat class="main">
    <div v-show="nextPage === 0" style="height: 60vh;" class="py-3">
      <v-row class="text-right" align="baseline">
        <v-col cols="2">
          <label class="body-2 font-weight-bold black--text">Cara Masuk</label>
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            tile
            :color="triase.entry === 'jalan' ? 'primary' : '#A6ADB4'"
            :outlined="triase.entry !== 'jalan'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.entry = 'jalan'"
            >Jalan</v-btn
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            :outlined="triase.entry !== 'brandcar'"
            tile
            :color="triase.entry === 'brandcar' ? 'primary' : '#A6ADB4'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.entry = 'brandcar'"
            >Brandcar</v-btn
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            tile
            :color="triase.entry === 'kursi roda' ? 'primary' : '#A6ADB4'"
            :outlined="triase.entry !== 'kursi roda'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.entry = 'kursi roda'"
            >Kursi Roda</v-btn
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            tile
            :color="triase.entry === 'digendong' ? 'primary' : '#A6ADB4'"
            :outlined="triase.entry !== 'digendong'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.entry = 'digendong'"
            >Digendong</v-btn
          >
        </v-col>
      </v-row>
      <v-row class="text-right" align="baseline">
        <v-col cols="2">
          <label class="body-2 font-weight-bold black--text"
            >Sudah Terpasang</label
          >
        </v-col>
        <v-col cols="2">
          <v-text-field dense v-model="triase.mounted[0]" />
          <v-text-field dense v-model="triase.mounted[1]" />
        </v-col>
      </v-row>
      <v-row class="text-right" align="baseline">
        <v-col cols="2">
          <label class="body-2 font-weight-bold black--text"
            >Alasan Kedatangan</label
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            tile
            :color="
              triase.reason.type === 'datang sendiri' ? 'primary' : '#A6ADB4'
            "
            :outlined="triase.reason.type !== 'datang sendiri'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.reason.type = 'datang sendiri'"
            >Datang Sendiri</v-btn
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            tile
            :color="triase.reason.type === 'polisi' ? 'primary' : '#A6ADB4'"
            :outlined="triase.reason.type !== 'polisi'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.reason.type = 'polisi'"
            >Polisi</v-btn
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            tile
            :color="triase.reason.type === 'rujukan' ? 'primary' : '#A6ADB4'"
            :outlined="triase.reason.type !== 'rujukan'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.reason.type = 'rujukan'"
            >Rujukan</v-btn
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            tile
            :color="triase.reason.type === 'dijemput' ? 'primary' : '#A6ADB4'"
            :outlined="triase.reason.type !== 'dijemput'"
            width="153"
            elevation="0"
            class="text-none"
            @click="triase.reason.type = 'dijemput'"
            >Dijemput</v-btn
          >
        </v-col>
      </v-row>
      <v-row
        class="text-right"
        align="baseline"
        v-show="triase.reason.type === 'rujukan'"
      >
        <v-col cols="2">
          <label class="body-2 font-weight-bold black--text"
            >Rujukan Dari</label
          >
        </v-col>
        <v-col cols="2">
          <v-text-field dense v-model="triase.reason.info"></v-text-field>
        </v-col>
      </v-row>
      <v-row
        class="text-right"
        align="baseline"
        v-show="triase.reason.type === 'dijemput'"
      >
        <v-col cols="2">
          <label class="body-2 font-weight-bold black--text"
            >Dijemput Oleh</label
          >
        </v-col>
        <v-col cols="2">
          <v-text-field dense v-model="triase.reason.info"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="text-right" align="baseline">
        <v-col cols="2">
          <label class="body-2 font-weight-bold black--text">Kendaraan</label>
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            :color="triase.vehicle === 'ambulance' ? 'primary' : '#A6ADB4'"
            :outlined="triase.vehicle !== 'ambulance'"
            tile
            depressed
            class="text-none"
            width="153"
            @click="triase.vehicle = 'ambulance'"
            >Ambulance</v-btn
          >
        </v-col>
        <v-col cols="2" class="text-left">
          <v-btn
            :color="triase.vehicle !== 'ambulance' ? 'primary' : '#A6ADB4'"
            :outlined="triase.vehicle === 'ambulance'"
            tile
            depressed
            class="text-none"
            width="153"
            @click="triase.vehicle = ''"
            >Lain-lain</v-btn
          >
        </v-col>
      </v-row>
      <v-row
        class="text-right"
        align="baseline"
        v-show="triase.vehicle !== 'ambulance'"
      >
        <v-col cols="2">
          <label class="body-2 font-weight-bold black--text"
            >Kendaraan Lain-lain</label
          >
        </v-col>
        <v-col cols="2">
          <v-text-field
            placeholder="Tulis kendaraan"
            dense
            v-model="triase.vehicle"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <div v-show="nextPage === 1" class="next-page">
      <v-row align="baseline">
        <v-col cols="2" class="text-right">
          <label class="body-2 font-weight-bold black--text"
            >Identitas Pengantar</label
          >
        </v-col>
        <v-col cols="2">
          <v-text-field
            placeholder="Nama Lengkap"
            dense
            v-model="triase.agent"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-row align="baseline">
            <v-col cols="3" class="text-right">
              <label class="body-2 font-weight-bold black--text"
                >Keadaan Waktu Tiba</label
              >
            </v-col>
            <v-col>
              <v-checkbox
                label="Tenang"
                color="success"
                hide-details="false"
                dense
                :value="1"
                v-model="triase.arrival_condition"
              ></v-checkbox>
              <v-checkbox
                label="Sesak Nafas"
                color="success"
                hide-details="false"
                dense
                :value="2"
                v-model="triase.arrival_condition"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                label="Gelisah"
                color="success"
                hide-details="false"
                dense
                :value="3"
                v-model="triase.arrival_condition"
              ></v-checkbox>
              <v-checkbox
                label="Oodem"
                color="success"
                hide-details="false"
                dense
                :value="4"
                v-model="triase.arrival_condition"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                label="Kesakitan"
                color="success"
                hide-details="false"
                dense
                :value="5"
                v-model="triase.arrival_condition"
              ></v-checkbox>
              <v-checkbox
                label="Pendarahan"
                color="success"
                hide-details="false"
                dense
                :value="6"
                v-model="triase.arrival_condition"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                label="Anemia"
                color="success"
                hide-details="false"
                dense
                :value="7"
                v-model="triase.arrival_condition"
              ></v-checkbox>
              <v-checkbox
                label="Penurunan Kesadaran"
                color="success"
                hide-details="false"
                dense
                :value="8"
                v-model="triase.arrival_condition"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                label="Luka"
                color="success"
                hide-details="false"
                dense
                :value="9"
                v-model="triase.arrival_condition"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row align="baseline">
        <v-col cols="2" class="text-right">
          <label class="body-2 font-weight-bold black--text"
            >Mekanisme Trauma</label
          >
        </v-col>
        <v-col>
          <v-checkbox
            label="Kecelakaan Lalu Lintas Tunggal"
            color="success"
            dense
            v-model="triase.trauma_mechanism.individual_accident.status"
          ></v-checkbox>
          <v-row>
            <v-col class="text-right" cols="2">
              <label class="black--text">Tempat kejadian :</label>
            </v-col>
            <v-col cols="2">
              <v-text-field
                dense
                placeholder="Tempat Kejadian"
                hide-details="false"
                v-model="triase.trauma_mechanism.individual_accident.place"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="
                  triase.trauma_mechanism.individual_accident.date
                "
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="triase.trauma_mechanism.individual_accident.date"
                    append-icon="mdi-chevron-down"
                    placeholder="Tanggal"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details="false"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="triase.trauma_mechanism.individual_accident.date"
                  no-title
                  scrollable
                  @input="
                    $refs.menu.save(
                      triase.trauma_mechanism.individual_accident.date,
                    );
                    menu = false;
                  "
                />
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="
                  triase.trauma_mechanism.individual_accident.time
                "
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="triase.trauma_mechanism.individual_accident.time"
                    placeholder="Waktu"
                    append-icon="mdi-chevron-down"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details="false"
                    clearable
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu2"
                  v-model="triase.trauma_mechanism.individual_accident.time"
                  full-width
                  format="24hr"
                  @click:minute="
                    $refs.menu2.save(
                      triase.trauma_mechanism.individual_accident.time,
                    );
                    menu2 = false;
                  "
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row justify="start" align="baseline">
            <v-col cols="3">
              <v-checkbox
                label="Kecelakaan Lalu Lintas antara :"
                color="success"
                dense
                hide-details="false"
                v-model="triase.trauma_mechanism.accident_between.status"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-text-field
                dense
                hide-details="false"
                v-model="triase.trauma_mechanism.accident_between.vehicle1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="pt-2">
              <label class="black--text">dengan</label>
            </v-col>
            <v-col cols="2">
              <v-text-field
                dense
                hide-details="false"
                v-model="triase.trauma_mechanism.accident_between.vehicle2"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="baseline">
            <v-col class="text-right" cols="2">
              <label class="black--text">Tempat kejadian :</label>
            </v-col>
            <v-col cols="2">
              <v-text-field
                placeholder="Tempat Kejadian"
                dense
                hide-details="false"
                v-model="triase.trauma_mechanism.accident_between.place"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                :return-value.sync="
                  triase.trauma_mechanism.accident_between.date
                "
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="triase.trauma_mechanism.accident_between.date"
                    append-icon="mdi-chevron-down"
                    placeholder="Tanggal"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details="false"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="triase.trauma_mechanism.accident_between.date"
                  no-title
                  scrollable
                  @input="
                    $refs.menu3.save(
                      triase.trauma_mechanism.accident_between.date,
                    );
                    menu3 = false;
                  "
                />
              </v-menu>
            </v-col>
            <v-col class="pt-0" cols="2">
              <v-menu
                ref="menu4"
                v-model="menu4"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="
                  triase.trauma_mechanism.accident_between.time
                "
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="triase.trauma_mechanism.accident_between.time"
                    placeholder="Waktu"
                    append-icon="mdi-chevron-down"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details="false"
                    clearable
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu4"
                  v-model="triase.trauma_mechanism.accident_between.time"
                  full-width
                  format="24hr"
                  @click:minute="
                    $refs.menu4.save(
                      triase.trauma_mechanism.accident_between.time,
                    );
                    menu4 = false;
                  "
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row align="baseline">
            <v-col cols="2" class="pr-0">
              <v-checkbox
                dense
                label="Jatuh dari ketinggian"
                color="success"
                hide-details="false"
                v-model="triase.trauma_mechanism.fall_trauma.status"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-text-field
                placeholder="Deskripsi"
                dense
                hide-details="false"
                v-model="triase.trauma_mechanism.fall_trauma.info"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="baseline">
            <v-col cols="2">
              <v-checkbox
                dense
                label="Luka bakar"
                color="success"
                v-model="triase.trauma_mechanism.burns_trauma.status"
              ></v-checkbox>
              <v-text-field
                placeholder="Deskripsi"
                dense
                v-model="triase.trauma_mechanism.burns_trauma.info"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                dense
                label="Trauma Listrik"
                color="success"
                v-model="triase.trauma_mechanism.electric_trauma.status"
              ></v-checkbox>
              <v-text-field
                placeholder="Deskripsi"
                dense
                v-model="triase.trauma_mechanism.electric_trauma.info"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                dense
                label="Trauma zat lainnya"
                color="success"
                v-model="triase.trauma_mechanism.substance_trauma.status"
              ></v-checkbox>
              <v-text-field
                placeholder="Deskripsi"
                dense
                v-model="triase.trauma_mechanism.substance_trauma.info"
              ></v-text-field>
            </v-col>
            <v-col cols="3" align-self="end">
              <v-combobox
                placeholder="ICD-10"
                dense
                :items="diagnose"
                item-value="_id"
                item-text="description"
                :loading="isLoadingDiagnose"
                v-model="triase.trauma_mechanism.icd_10"
                :search-input.sync="searchDiagnose"
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="text-right">
              <label class="black--text">Keluhan utama :</label>
            </v-col>
            <v-col cols="3">
              <v-text-field
                placeholder="Deskripsi"
                dense
                v-model="triase.trauma_mechanism.primary_complaint"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-card-actions class="px-0 footer">
      <v-btn text class="text-none" @click="$emit('close-form')">Kembali</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-show="nextPage === 0"
        color="black"
        width="180"
        class="text-none white--text"
        elevation="0"
        tile
        @click="nextPage = 1"
        >Halaman Selanjutnya</v-btn
      >
      <v-btn
        v-show="nextPage === 1"
        color="primary"
        elevation="0"
        tile
        class="text-none white--text"
        width="153"
        @click="addTriase()"
        >Simpan</v-btn
      >
      <v-btn
        v-show="nextPage === 1"
        color="black"
        width="180"
        class="text-none white--text"
        elevation="0"
        tile
        @click="nextPage = 0"
        >Halaman Sebelumnya</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import Constant from '@/const';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';

const _ = require('lodash');
const axios = require('axios');
export default {
  name: 'TriaseCard',
  props: {
    triaseLevel: {
      type: Object,
    },
    wpss: {
      type: Object,
    },
    triase: {
      type: Object,
    },
    triaseNumber: {
      type: Number,
    },
    patientData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      nextPage: 0,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      diagnose: [],
      searchDiagnose: '',
      other: false,
      isLoadingDiagnose: false,
    };
  },
  mounted() {
    this.getDiagnose('');
  },
  watch: {
    searchDiagnose(val) {
      if (val) {
        this.debouncedSearch(val);
      }
    },
  },
  methods: {
    debouncedSearch: _.debounce(function(val) {
      this.getDiagnose(val);
    }, 700),
    getDiagnose(keyword) {
      this.isLoadingDiagnose = true;
      axios
        .get(
          Constant.apiUrl.concat(
            `/master/diagnose?page=1&itemCount=100&search=${keyword ||
              ''}&sort=-code`,
          ),
        )
        .then(response => {
          this.diagnose = response.data.data;
        })
        .finally(() => {
          this.isLoadingDiagnose = false;
        });
    },
    addTriase() {
      const payload = {
        id_patient: null,
        id_registration: null,
        id_poly: null,
        triase_number: this.triaseNumber,
        detail_triase: [
          {
            filled_at: moment(new Date())
              .locale('id')
              .format(),
            triase_level: {
              name: this.triaseLevel.name,
              gender: this.triaseLevel.gender,
              person_in_charge: this.triaseLevel.pic,
              address: this.triaseLevel.address,
              parent_name: this.triaseLevel.parentsName,
              pacs: this.triaseLevel.pacs,
              awareness: this.triaseLevel.awareness,
              blood_pressure_sistole: this.triaseLevel.sistole,
              blood_pressure_diastole: this.triaseLevel.diastole,
              temperature: this.triaseLevel.temperature,
              pulse: this.triaseLevel.pulse,
              saturation: this.triaseLevel.saturation,
              respiratory: this.triaseLevel.respiration,
              pain: this.triaseLevel.pain,
              weight_body: this.triaseLevel.weight,
              height_body: this.triaseLevel.height,
            },
            wpss: this.wpss,
            triase: {
              ...this.triase,
              trauma_mechanism: {
                ...this.triase?.trauma_mechanism,
                icd_10: this.triase?.trauma_mechanism?.icd_10?._id,
              },
            },
            timestamps: {
              created_by: this.$store.getters.userLoggedIn.id,
            },
          },
        ],
      };

      axios
        .post(Constant.apiUrl.concat('/patient/igd/triase'), payload)
        .then(() => {
          if (this.patientData !== null) {
            Swal.fire('Triase Berhasil diperbaharui', '', 'success');
            this.$emit('close-form');
          } else {
            Swal.fire('Triase Berhasil didaftarkan', '', 'success');
            this.$emit('close-form');
          }
        })
        .catch(err => {
          this.showErrorAxios(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-label {
  color: black;
  font-size: 14px;
}

.next-page {
  height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 3px;
    background-color: grey;
  }
  &::-webkit-scrollbar-button {
    width: 3px;
    background-color: black;
  }
}

::v-deep .v-text-field fieldset,
.v-text-field .v-input__control {
  max-height: 50px;
}

.main {
  position: relative;
}

.footer {
  position: absolute;
  width: 100%;
  bottom: -10vh;
}
</style>
